import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen theme-bg-primary flex items-center justify-center py-12 sm:px-6 lg:px-8">
      <div className="max-w-4xl w-full h-[calc(100vh-200px)] overflow-y-auto">
        <div className="theme-bg-secondary py-8 px-4 shadow-xl sm:rounded-lg sm:px-10 theme-border border pb-[70px]">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-3">
              <Logo size="xxxl" />
            </div>
            <h2 className="text-1xl theme-text-secondary mb-4">
              Let's respect the market
            </h2>
            <h1 className="text-3xl font-bold theme-text-primary mb-4">
              Privacy Policy
            </h1>
            <p className="theme-text-quaternary text-sm">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="prose prose-invert max-w-none theme-text-secondary space-y-6">
            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                1. Information We Collect
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We collect information you provide directly to us, such as when
                you create an account, make a transaction, or contact us for
                support. This may include your name, email address, phone
                number, and financial information.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                2. How We Use Your Information
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We use the information we collect to provide, maintain, and
                improve our services, process transactions, send you technical
                notices and support messages, and communicate with you about
                products, services, and events.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                3. Information Sharing
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We do not sell, trade, or otherwise transfer your personal
                information to third parties without your consent, except as
                described in this policy. We may share information with service
                providers who assist us in operating our platform.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                4. Data Security
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We implement appropriate security measures to protect your
                personal information against unauthorized access, alteration,
                disclosure, or destruction. However, no method of transmission
                over the internet is 100% secure.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                5. Cookies and Tracking
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We use cookies and similar tracking technologies to enhance your
                experience on our platform. You can control cookie settings
                through your browser preferences, but disabling cookies may
                affect some functionality.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                6. Third-Party Services
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                Our platform may contain links to third-party websites or
                services. We are not responsible for the privacy practices of
                these third parties. We encourage you to review their privacy
                policies.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                7. Data Retention
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We retain your personal information for as long as necessary to
                provide our services and comply with legal obligations. You may
                request deletion of your account and associated data at any
                time.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                8. Your Rights
              </h3>
              <ul className="list-disc list-inside theme-text-secondary leading-relaxed space-y-2 ml-4">
                <li>Access and review your personal information</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of marketing communications</li>
                <li>Request data portability</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                9. Children's Privacy
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                Our services are not intended for children under 18 years of
                age. We do not knowingly collect personal information from
                children under 18. If you believe we have collected such
                information, please contact us immediately.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                10. Changes to This Policy
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                We may update this Privacy Policy from time to time. We will
                notify you of any changes by posting the new policy on this page
                and updating the "Last updated" date.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold theme-text-primary mb-3">
                11. Contact Us
              </h3>
              <p className="theme-text-secondary leading-relaxed">
                If you have any questions about this Privacy Policy or our data
                practices, please contact us at privacy@livetradingstudio.com
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t theme-border">
            <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
              <Link
                to="/terms-and-conditions"
                className="text-[#2AB7A6] hover:text-[#25A395] font-medium"
              >
                ← Terms and Conditions
              </Link>
              <Link
                to="/register"
                className="text-[#2AB7A6] hover:text-[#25A395] font-medium"
              >
                Back to Registration →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
